<template>
  <div
    v-if="sessionName"
    id="journeyTasks"
    class="mainCard"
  >
    <!-- Title -->
    <div class="taskTitle defaultCursor">
      My Tasks
    </div>

    <hr />

    <div class="taskContents">
      <!-- Task list -->
      <ul
        v-if="sessionTaskData.tasks.length"
        class="taskUl"
      >
        <template v-for="(task, TaskKey) in sessionTaskData.tasks">
          <li
            :key="`Task${TaskKey}`"
            class="taskLi defaultCursor"
          >
            {{ $t(`processTasks.${task}`) }}
          </li>
        </template>
      </ul>

      <!-- Document list -->
      <ul
        v-if="sessionTaskData.documents.length"
        class="docUl"
      >
        <template v-for="(doc, DocKey) in sessionTaskData.documents">
          <li
            :key="`Doc${DocKey}`"
            class="docLi"
            @click="modalActivate(doc.key)"
          >
            <i class="docIcon el-icon-document"></i>
            <div class="docTitle">
              {{ doc.title }}
            </div>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import taskData from './data/taskData';

export default {
  props: {
    sessionId: {
      type: String,
      default: null,
    },

    modalType: {
      type: String,
      default: null,
    },

    modalVisible: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    sessionName() {
      let name = '';
      if (this.sessionId) {
        name = `session_${this.sessionId}`;
      }
      return name;
    },

    sessionTaskData() {
      let obj = {
        tasks: [],
        document: [],
      };

      if (this.sessionId && this.sessionName) {
        obj = taskData[this.sessionName];
      }

      return obj;
    },
  },

  methods: {
    modalActivate(key) {
      this.$emit('update:modalType', key);
      this.$emit('update:modalVisible', true);
    },
  },
};
</script>

<style lang="scss" scoped>
  #journeyTasks {
    hr {
      border-bottom: none;
      border-top: 1px solid var(--themeFontColor);
      margin: 0;
    }

    .taskTitle {
      color: var(--themeFontColor);
      font-weight: bold;
      font-size: 18px;
      padding: 15px 0 15px;
    }

    .taskContents {
      padding: 15px 30px 30px;
      color: var(--themeFontColor);

      .taskUl {
        padding: 0 0 0 18px;
        margin: 0;
        font-size: 16px;

        .taskLi:not(:last-child) {
          margin-bottom: 20px;
        }
      }

      .docUl {
        padding: 0;
        margin: 15px -20px 0;
        font-size: 16px;
        list-style: none;

        .docLi {
          display: flex;
          align-items: center;
          transition: all 150ms ease;
          padding: 8px 14px;
          cursor: pointer;

          &:hover {
            background-color: rgba(255, 255, 255, 0.2);

            .docTitle {
              text-decoration: underline;
            }
          }

          .docIcon {
            font-size: 26px;
            padding-right: 14px;
          }
        }
      }
    }
  }
</style>
